export default "__VITE_ASSET__310bc1a9__"